import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemWebhooksRoute: InvariantJiraRoute = {
	name: 'global-settings-system-webhooks',
	path: '/plugins/servlet/webhooks',
};
